export default __webpack_public_path__ + "static/media/set-fan-background.759002e5.png";